import { createContext, type ReactNode, useContext, useRef } from "react";

type FeedSearchControl = {
    registerOpener: (open: (() => void) | null) => void;

    openSearch: () => void;
};

const FeedSearchControlContext = createContext<FeedSearchControl | null>(null);

export function FeedSearchProvider({ children }: { children: ReactNode }) {
    const openerRef = useRef<(() => void) | null>(null);
    const control: FeedSearchControl = {
        registerOpener: (open) => {
            openerRef.current = open;
        },
        openSearch: () => openerRef.current?.(),
    };
    return (
        <FeedSearchControlContext.Provider value={control}>
            {children}
        </FeedSearchControlContext.Provider>
    );
}

export function useRegisterFeedSearchOpener(open: () => void) {
    const control = useContext(FeedSearchControlContext);
    return (element: HTMLElement | null) => {
        if (!control || !element) return;
        control.registerOpener(open);
        return () => control.registerOpener(null);
    };
}

const noop = () => {};

export function useOpenFeedSearch(): () => void {
    return useContext(FeedSearchControlContext)?.openSearch ?? noop;
}
